import { defineFcm } from '../shared/factory';

export const FCM_HIGH_AMOUNT_CONFIRMATION_MODAL = defineFcm('high_amount_confirmation_modal')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform-payments',
		scope: 'corgi-front-end',
		context: 'Corgi Promote Page',
		description: `Shows/Hides the high amount confirmation modal
		popup on:
			- the Corgi Promote page
			- the Promote Async page`,
	});
